// What leaves the customizer with a design, out of CustomizerScreen and PlaceOrderScreen
// (backfill PR 31): the keycap rows without their spacers, as POST /api/designs and
// /api/designs/place-order take them (a design document stores only what differs from the
// layout and the keycap defaults, and both come back from the layout when it is loaded), the
// name a saved design takes from the name field, whether a cart item is a custom layout, and
// the cart item the customizer adds (chain 8, Oct 2026).
export function prepareKeycapDataForUpload(keycapData) {
  return keycapData.map(
    (row) => row.filter((keycap) => !keycap.isSpacer) // filter out spacers (other keycap data like width and height is not included in the design documents anyway, as these fields are not defined in the design schema)
  );
} // the rows POST /api/designs and /api/designs/place-order receive (CustomizerScreen and PlaceOrderScreen held a copy each until PR 31)

export const designNameToSave = (designName) => {
  const trimmed = designName.trim();
  return trimmed.length < 2 ? null : trimmed;
}; // the name the save modal's field gives a design, or null when it is shorter than two characters after trimming

export const isCustomLayoutCartItem = (design, product) =>
  Boolean(
    design?.metadata?.isCustomLayout ?? product?.visibility === 'restricted'
  ); // derive whether this design is based on a custom layout - fallback to product visibility (savedDesignCartItem's mark takes it too, since chain 8)

export const customizerCartItem = (
  product,
  design,
  quantity,
  uniqueCartId
) => ({
  ...product, // Base product information
  quantity, // User-specified quantity
  uniqueCartId, // Reference ID for the large data in IndexedDB
  keycapProfile: design.profileEditor.profile,
  isCustomLayout: isCustomLayoutCartItem(design, product),
}); // the cart item the customizer adds: the product's fields with the sets and the profile, under the id its design and preview are stored in IndexedDB by (the saved-design lists' sibling, with a designId and a thumbnail, is savedDesignCartItem in savedDesigns.js)
